import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "timeline-skeleton",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "sk-head" }
const _hoisted_3 = { class: "sk-photos" }

const NUM_ROWS = 10;


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'TimelineSkeleton',
},
  __name: 'TimelineSkeleton',
  setup(__props) {



const rows = Array.from({ length: NUM_ROWS }, (_, r) => {
  const count = 3 + (r % 3);
  const widths = Array.from({ length: count }, (_, c) => 0.8 + ((r * 7 + c * 13) % 10) / 10);
  return {
    id: r,
    widths,
    headWidth: 50 + ((r * 17) % 80),
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rows), (row) => {
      return (_openBlock(), _createElementBlock("div", {
        key: row.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "sk-bar ph-shimmer",
            style: _normalizeStyle({ width: `${row.headWidth}px` })
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.widths, (width, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "sk-photo ph-shimmer",
              style: _normalizeStyle({
            flexGrow: width,
            animationDelay: `${(row.id * 0.12 + i * 0.05).toFixed(2)}s`,
          })
            }, null, 4))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}
}

})